import React from "react";
import { Card, CardContent, Chip, Grid, styled, Typography } from "@mui/material";
import { MemberMessage } from "../../../../service/model/message.model";
import { toTitleCase } from "../../../../shared/utils";

const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: "12px",
    '& .MuiCardContent-root': {
        paddingBottom: '12px !important',
    }
}));

interface MessageHistoryProps {
    messages: MemberMessage[];
}

const MessageHistory: React.FC<MessageHistoryProps> = ({ messages }) => {
    return (
        <div style={{ marginTop: '12px' }}>
            <Typography variant="h6">Message History</Typography>
            {messages.map(message => {
                return <StyledCard key={message.id}>
                    <CardContent sx={{ pb: '12px' }}>
                        <Grid container alignItems="center">
                            <Grid size={{ xs: 12, md: 10 }}>
                                <Grid size={{ xs: 12, md: 2 }}>
                                    <Chip sx={{mb: 1}} label={toTitleCase(message.messageType.replace('_', ' '))} variant="outlined" color="success"  size="small"/>
                                </Grid>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14, whiteSpace: 'pre-line' }} align="left">
                                    {message.messageContent}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 2 }}>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14 }} align="left">
                                    {message.createdOn.replace('T', ' ').substring(0, 19)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </StyledCard>
            })

            }
        </div>
    );
}

export default MessageHistory;